__webpack_require__.p = "/othello/";